import Image from 'next/image'

import { cn } from '@/core/utils/common'

/*
 * 게임 아이템 그림(2026-10-01 생성 · GPT Image 2.5 · 투명 배경, 256px webp) — public/images/veluvit/items/.
 * 재화(젬 · 해금권)는 currency-icon 이 이 그림으로 어디서나 그린다. 퀘스트 문장 · 선물 · 트로피는 20px 이상,
 * 세계관 문장(q-world)은 그림이 촘촘해 28px 이상에서만.
 */
/** 그림을 다시 뽑아 바꾼 것 — 이미지 최적화 캐시가 옛 그림을 내주지 않게 파일 이름을 바꾼다 */
const FILE: Partial<Record<ItemName, string>> = { gift: 'gift-wide' }

/** lock — 잠긴 장면 카드 자물쇠(2026-10-07 GPT Image 2 · 진주빛 하트 자물쇠, 배경 제거 후 256px) */
type ItemName =
  | 'gem'
  | 'ticket'
  | 'gift'
  | 'trophy'
  | 'lock'
  | 'q-character'
  | 'q-world'
  | 'q-command'
  | 'q-status'

/**
 * 크기는 className 의 size-* 로 정한다(기본 1.25em — 글자 옆). px 은 받아 올 원본 해상도: 화면 크기의 2배 정도로(기본 64 → 32px 까지 선명).
 * 장식이면 alt 를 비워 둔다(기본). 뜻이 있는 그림이면 alt 를 준다.
 */
export function ItemArt({
  name,
  className,
  px = 64,
  alt = '',
}: {
  name: ItemName
  className?: string
  px?: 32 | 64 | 128 | 256
  alt?: string
}) {
  return (
    <Image
      src={`/images/veluvit/items/${FILE[name] ?? name}.webp`}
      alt={alt}
      aria-hidden={alt ? undefined : true}
      width={px}
      height={px}
      draggable={false}
      // cn 은 충돌 클래스를 병합하지 않는다 — 쓰는 쪽이 size-* 를 주면 기본 크기를 빼서 둘이 겹치지 않게
      className={cn(
        'inline-block flex-none object-contain select-none',
        !className?.includes('align-') && 'align-[-0.25em]',
        !className?.includes('size-') && 'size-[1.25em]',
        className
      )}
    />
  )
}
